<template>
    <div class="drawer">
        <div v-if="trayType === 'Chat'" class="chat-header-arrow"></div> 
        <div v-if="trayType === 'Chat'" class="chat-header">
            <div class="title chatTitle">{{trayType}}</div>
            <a v-on:click="close" class="btn-right">
                <i class="fa fa-times"></i>
            </a>
        </div>
        <div v-else class="tray-header">
            <img v-if="trayType === 'Questions'" class="header-icon" src="../assets/icons/questions_selected.svg">
            <img v-if="trayType === 'People'" class="header-icon" src="../assets/icons/people_selected.svg">
            <img v-if="trayType === 'Sessions'" class="header-icon" src="../assets/icons/sessions_selected.svg">
            <div class="title">{{trayType}}</div>
            <a v-if="presentation" v-on:click="close" class="btn-right">
                <i class="fa fa-times"></i>
            </a>
        </div>
        <sessionstray v-if="trayType === 'Sessions'" :presentations="presentationList" :isLoading="isLoading"></sessionstray>
        <questiontray v-if="trayType === 'Questions'" :peopleMap="peopleMap" :questions="questionList" :user="user"></questiontray>
        <peopletray v-if="trayType === 'People'" :people="peopleList" :user="user"></peopletray>
        <chattray v-if="trayType === 'Chat'" :presentation="presentation" :person="person" :user="user" :contacts="chatContacts" :chatList="chatList" :peopleMap="peopleMap" v-on:updateChat="updateChat($event)"></chattray>
    </div>
</template>

<script>
// TODO: get timeout working.
import SessionsTray from '@/components/SessionsTray';
import PeopleTray from '@/components/PeopleTray';
import QuestionTray from '@/components/question/QuestionTray';
import ChatTray from '@/components/chat/ChatTray';

export default {
    components: {
        sessionstray: SessionsTray,
        peopletray: PeopleTray,
        questiontray: QuestionTray,
        chattray: ChatTray
    },

    props: {
        trayType: '',
        presentation: {},
        presentationList: {},
        peopleList: {},
        questionList: {},
        peopleMap: {},
        user: {},
        person: {},
        chatList: {},
        chatContacts: {},
        isLoading: Boolean
    },

    data () {
        return {
            trayOpen: false
        };
    },

    methods: { 
        close() {
            this.$emit('closeTray');
        }
    }
};

</script>

<style lang="scss">
.drawer {
    background-color: #000000;
    background-position: center; 
    height: 100%;
    padding: 0;
    color: #fff;
    box-sizing: inherit;
    z-index: 4000;
    position: absolute;
    width: 100%;
    top:0px;

    .chat-header {
        display: table;
        padding: 5px 0;
        line-height: 40px;
        background-color: #333;
        user-select: none;
        margin-left: 20px;
        margin-right: auto;
        width: calc(100% - 30px);
        margin-top: 10px;
        margin-bottom: 5px;
        border-radius: 10px;     

        .chatTitle {
            padding-left: 40px;
        }
    }
    
    .tray-header {
        display: table;
        padding: 5px 0;
        line-height: 40px;
        background-color: #333;
        user-select: none;
        margin-left: auto;
        margin-right: auto;
        width: calc(100% - 20px);
        margin-top: 10px;
        margin-bottom: 5px;
        border-radius: 10px 10px 0 0;

        .header-icon {
            display: table-cell;
            width: 35px;
            height: 35px;
            vertical-align: middle;
            margin-left: 15px;
            padding-bottom: 5px;
        }
    }   

    .title {
        display: table-cell;
        vertical-align: middle;
        font-weight: 500;
        font-size: 1em;
        font-family: 'Poppins', sans-serif;
        text-align: center;
        width: 100%;
    }

    .btn-right {
        font-size: 20px;
        vertical-align: middle !important;
        color: #fff;
        width: 35px;
        cursor: pointer;
        float: right;
        margin-left: 15px;
    }

    .chat-header-arrow {
        position: fixed;
        display: block;
        border: solid transparent;
        border-right-color: #333;
        content: '';
        height: 0;
        width: 0;
        left: -8px;
        top: 20px;
        border-width: 15px;
    }
}

</style>



// WEBPACK FOOTER //
// BottomTray.vue?48a47f68